<template>
  <section class="policy-info__detail">
    <h5 class="mb-1 fs-7 text-gray-700 mb-2">Связанные договоры</h5>
    <div v-for="linkedPolicy in linkedPolicies" :key="linkedPolicy.id" class="podft-list p-4 rounded border mb-5">
      <div v-if="linkedPolicy.product" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Номер договора
          <span
            class="text-primary float-end cursor-pointer"
            role="button"
            tabindex="0"
            :title="'Скопировать: ' + getContractNumber(linkedPolicy)"
            @click="copyContractNumber(linkedPolicy)"
            @keydown.enter.prevent="copyContractNumber(linkedPolicy)"
          >{{ getContractNumber(linkedPolicy) }}</span>
        </div>
      </div>
      <div v-if="linkedPolicy.product" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Продукт (код)
          <span class="text-gray-800 float-end">{{linkedPolicy.product}}</span>
        </div>
      </div>
      <div v-if="linkedPolicy.premium" class="podft-list__item">
        <div class="text-gray-600 fs-7"> Премия
          <span class="text-gray-800 float-end">{{ linkedPolicy.premium.toLocaleString('ru-RU') }} тг.</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PolicyLinked',
  props: {
    linked: null
  },
  computed: {
    linkedPolicies() {
      return this.linked ?? []
    }
  },
  methods: {
    getContractNumber(linkedPolicy) {
      return linkedPolicy?.global_id || linkedPolicy?.global || ''
    },
    async copyContractNumber(linkedPolicy) {
      const text = String(this.getContractNumber(linkedPolicy)).trim()
      if (!text) return

      try {
        await navigator.clipboard.writeText(text)
        this.$notifySuccess({ message: 'Номер ' + text + ' скопирован' }, { duration: 500 })
      } catch {
        const textarea = document.createElement('textarea')
        textarea.value = text
        textarea.setAttribute('readonly', '')
        textarea.style.position = 'absolute'
        textarea.style.left = '-9999px'
        document.body.appendChild(textarea)
        textarea.select()
        try {
          document.execCommand('copy')
          this.$notifySuccess({ message: 'Номер ' + text + ' скопирован' }, { duration: 500 })
        } catch {
          this.$notifyError({ message: 'Не удалось скопировать номер ' + text }, { duration: 500 })
        } finally {
          document.body.removeChild(textarea)
        }
      }
    },
    getStyle(status) {
      if (status === 0) return 'bg-primary'
      if (status === 1) return 'bg-success'
      if (status === 2) return 'bg-danger'
      if (status >= 3) return 'bg-warning'
    }
  }
}
</script>

<style scoped>

</style>